import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = (measurementId: string) => {
    ReactGA.initialize(measurementId);
};

// Track page views
export const trackPageView = (path: string) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const trackEvent = (
    category: string,
    action: string,
    label?: string,
    value?: number
) => {
    ReactGA.event({
        category,
        action,
        label,
        value,
    });
};

// Predefined event categories
export const AnalyticsCategories = {
    AUTH: 'Authentication',
    SUBSCRIPTION: 'Subscription',
    GMAIL: 'Gmail Integration',
    ANALYTICS: 'Analytics',
    SETTINGS: 'Settings',
    USER: 'User',
};

// Predefined event actions
export const AnalyticsActions = {
    LOGIN: 'Login',
    SIGNUP: 'Signup',
    LOGOUT: 'Logout',
    CREATE: 'Create',
    UPDATE: 'Update',
    DELETE: 'Delete',
    IMPORT: 'Import',
    EXPORT: 'Export',
    CONNECT: 'Connect',
    DISCONNECT: 'Disconnect',
    FILTER: 'Filter',
};
